import type { TFunction } from 'i18next';
import { z } from 'zod';

export const EMAIL_FIELD_KEYS = [
	'emailCda_V',
	'email2_V',
	'email3_V',
	'email4_V',
	'email5_V'
] as const;

export type EmailFieldKey = (typeof EMAIL_FIELD_KEYS)[number];

export type EmailSequenceData = Partial<Record<EmailFieldKey, string | null>>;

export const validateEmailSequence =
	(t: TFunction, enabled: boolean) =>
	(data: EmailSequenceData, ctx: z.RefinementCtx) => {
		if (!enabled) return;

		let seenEmpty = false;
		EMAIL_FIELD_KEYS.forEach(key => {
			if (!data[key]) {
				seenEmpty = true;
				return;
			}

			if (seenEmpty) {
				ctx.addIssue({
					code: 'custom',
					path: [key],
					message: t
						? t('Fill in the previous email field first')
						: 'Fill in the previous email field first'
				});
			}
		});
	};

const emailRowShape = Object.fromEntries(
	EMAIL_FIELD_KEYS.map(key => [key, z.string()])
) as Record<EmailFieldKey, z.ZodString>;

export const EmailSequenceSchema = (t: TFunction, enabled: boolean) =>
	z.object(emailRowShape).superRefine(validateEmailSequence(t, enabled));
